import React, { useState, useEffect } from 'react';
import styles from '../app.module.css';

const Examples = ({ examples, addExample, editExample, removeExample }) => {
    const [editingExample, setEditingExample] = useState(null);
    const [deleteCandidate, setDeleteCandidate] = useState(null);
    const [popupType, setPopupType] = useState(null);
    const [exampleData, setExampleData] = useState({
        name: '',
        value: '',
    });

    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const showPopupModal = (message) => {
        setPopupMessage(message);
        setPopupType('error');
        setShowPopup(true);
    };

    useEffect(() => {
        if (editingExample && examples[editingExample]) {
            const existingExample = examples[editingExample];
            setExampleData({
                name: editingExample,
                value: JSON.stringify(existingExample.value || existingExample, null, 2),
            });
        }
    }, [editingExample, examples]);

    const handleInputChange = (field, value) => {
        setExampleData((prev) => ({ ...prev, [field]: value }));
    };

    const handleAdd = () => {
        setExampleData({ name: '', value: '' });
        setEditingExample('add');
    };

    const handleSave = () => {
        if (!exampleData.name || !exampleData.value) {
            showPopupModal('Name and Value are required.');
            return;
        }
        if (editingExample === 'add' && examples.hasOwnProperty(exampleData.name)) {
            showPopupModal(`An example with the name "${exampleData.name}" already exists. Please choose a different name.`);
            return;
        }
        try {
            const parsedValue = JSON.parse(exampleData.value);
            if (editingExample === 'add') {
                addExample({ name: exampleData.name, value: parsedValue });
            } else {
                editExample(editingExample, { value: parsedValue });
            }
            setEditingExample(null);
        } catch (error) {
            showPopupModal('Invalid JSON format in the Value field.');
        }
    };

    const handleCancel = () => {
        setEditingExample(null);
        setExampleData({ name: '', value: '' });
    };

    const handleDelete = (name) => {
        setDeleteCandidate(name);
        setPopupMessage(`Are you sure you want to delete the example "${name}"?`);
        setPopupType('confirm-delete');
        setShowPopup(true);
    };


    return (
        <div className="examples-container">
            <h3 className={styles.centeredHeading}>Examples</h3>
            <div>
                {Object.keys(examples).length === 0 && !editingExample}
                {Object.entries(examples).map(([name, value]) => (
                    <div
                        key={name}
                        className={styles.mainContainer}
                    >
                        {editingExample === name ? (
                            <>
                                <div className={styles.style4}>
                                    <label>Name: <span className={styles.requiredField}>*</span></label>
                                    <input
                                        type="text"
                                        value={exampleData.name}
                                        readOnly
                                        className={styles.textBox}
                                    />
                                </div>
                                <div className={styles.style4}>
                                    <label>Value (JSON): <span className={styles.requiredField}>*</span></label>
                                    <textarea
                                        value={exampleData.value}
                                        onChange={(e) => handleInputChange('value', e.target.value)}
                                        className={styles.textBox}
                                    />
                                </div>
                                <div className={styles.sNcButtonContainer}>
                                    <button
                                        onClick={handleSave}
                                        className={styles.saveButton}
                                    >
                                        Save
                                    </button>
                                    <button
                                        onClick={handleCancel}
                                        className={styles.cancelButton}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <p>
                                    <strong>Name:</strong> {name}
                                </p>
                                <p>
                                    <strong>Value:</strong>
                                </p>
                                <pre
                                    className={styles.jsonExample}
                                >
                                    <code>{JSON.stringify(value.value || value, null, 2)}</code>
                                </pre>
                                <div
                                    className={styles.actionButtonsContainer}
                                >
                                    <button
                                        onClick={() => setEditingExample(name)}
                                        className={styles.editButton}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDelete(name)}
                                        className={styles.deleteButton}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
            {editingExample === 'add' && (
                <div className={styles.mainContainer}>
                    <h3>Add Example</h3>
                    <div className={styles.style4}>
                        <label>Name: <span className={styles.requiredField}>*</span></label>
                        <input
                            type="text"
                            value={exampleData.name}
                            onChange={(e) => handleInputChange('name', e.target.value)}
                            className={styles.textBox}
                        />
                    </div>
                    <div className={styles.style4}>
                        <label>Value (JSON): <span className={styles.requiredField}>*</span></label>
                        <textarea
                            value={exampleData.value}
                            onChange={(e) => handleInputChange('value', e.target.value)}
                            className={styles.textBox}
                        />
                    </div>
                    <div className={styles.sNcButtonContainer}>
                        <button
                            onClick={handleSave}
                            className={styles.saveButton}
                        >
                            Save
                        </button>
                        <button
                            onClick={handleCancel}
                            className={styles.cancelButton}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
            {editingExample !== 'add' && (
                <button
                    onClick={handleAdd}
                    className={styles.addNewButton}
                >
                    + Add Example
                </button>
            )}
            {showPopup && (
                <div className={styles.popupOverlay}>
                    <div className={styles.popup}>
                        {popupType === 'confirm-delete' && (
                            <>
                                <h3>Confirm Delete</h3>
                                <p>{popupMessage}</p>
                                <div className={styles.sNcButtonContainer}>
                                    <button
                                        onClick={() => {
                                            if (deleteCandidate) removeExample(deleteCandidate);
                                            setDeleteCandidate(null);
                                            setPopupType(null);
                                            setShowPopup(false);
                                        }}
                                        className={styles.deleteButton}
                                    >
                                        OK
                                    </button>
                                    <button
                                        onClick={() => {
                                            setDeleteCandidate(null);
                                            setPopupType(null);
                                            setShowPopup(false);
                                        }}
                                        className={styles.cancelButton}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </>
                        )}
                        {popupType === 'error' && (
                            <>
                                <h3>Error</h3>
                                <p>{popupMessage}</p>
                                <button
                                    onClick={() => {
                                        setPopupType(null);
                                        setShowPopup(false);
                                    }}
                                    className={styles.popupButton}
                                >
                                    OK
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Examples;
